import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import PlantEquipment from './pages/PlantEquipment';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Gallery from './pages/Gallery';

// Scroll to top component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Placeholder components for other pages
const PlaceholderPage = ({ title }) => (
  <div className="min-h-screen bg-background text-foreground flex flex-col items-center justify-center">
    <div className="text-center p-8 border border-primary/20 rounded-xl bg-card">
      <h1 className="text-4xl font-serif text-primary mb-4">{title}</h1>
      <p className="text-muted-foreground mb-6">This page is under construction.</p>
      <a href="/" className="px-6 py-2 bg-primary text-background rounded-full font-bold hover:bg-primary/90 transition-colors">Back to Home</a>
    </div>
  </div>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/plant-equipment" element={<PlantEquipment />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </Router>
  );
}

export default App;
